"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeLocksChair_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Chair_1 = require("./Chair");
var TimeLocksChair_Factory = /** @class */ (function () {
    function TimeLocksChair_Factory() {
    }
    TimeLocksChair_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Chair: Chair_1.Chair_Factory.CreateIncoming(model.Chair),
            ChairId: model.ChairId,
            LegacyKey: model.LegacyKey,
            LegacyKeyHash: model.LegacyKeyHash,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TimeLockId: model.TimeLockId,
        };
        return result;
    };
    TimeLocksChair_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Chair: Chair_1.Chair_Factory.CreateOutgoing(model.Chair),
            ChairId: model.ChairId,
            LegacyKey: model.LegacyKey,
            LegacyKeyHash: model.LegacyKeyHash,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TimeLockId: model.TimeLockId,
        };
        return result;
    };
    return TimeLocksChair_Factory;
}());
exports.TimeLocksChair_Factory = TimeLocksChair_Factory;
